import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { getTemplate } from '@rjsf/utils';
import type { Control } from 'react-hook-form';

import { FormInput } from '../../form/FormInput/FormInput.js';
import { FormTextArea } from '../../form/FormTextArea/FormTextArea.js';
import type { GenericFormField } from '../../form/GenericForm/GenericForm.types.js';
import { FormCountry } from '../FormCountry/FormCountry.js';
interface Props {
  field: { name: string };
  control: Control;
}

/**
 * field.name path should point to object that contains Address/ZodAddress type
 */
export const FormAddressField = (props: Props) => {
  return (
    <Grid container rowGap={5} columnSpacing={1.5}>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormInput
          control={props.control}
          field={{
            name: `${props.field.name}.city`,
            placeholder: 'City',
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormInput
          control={props.control}
          field={{
            name: `${props.field.name}.state`,
            placeholder: 'State or region',
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormCountry
          control={props.control}
          field={{
            name: `${props.field.name}.country`,
            placeholder: 'Select country',
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormInput
          control={props.control}
          field={{
            name: `${props.field.name}.postalCode`,
            placeholder: 'Postal code',
          }}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <FormTextArea
          control={props.control}
          field={{
            name: `${props.field.name}.addressLine`,
            placeholder: 'Address',
          }}
        />
      </Grid>
    </Grid>
  );
};
